import { render, staticRenderFns } from "./select-sku.vue?vue&type=template&id=b5333fd0&scoped=true&"
import script from "./select-sku.vue?vue&type=script&lang=js&"
export * from "./select-sku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5333fd0",
  null
  
)

export default component.exports